export default class common {
  // window.location.origin can be https://local.3dvieweronline.com or https://3djeegbox.3dvieweronline.com or https://www.3dvieweronline.com
  //instead of defining an hard coded value, we let the system evaluating which server it is executed from
  constructor() {
    this.baseUrl = `${window.location.protocol}//${window.location.host}`;
    this.modelApi = `${this.baseUrl}/api/v1/models/`;
    this.wpApi = `${this.baseUrl}/wp-json/3dvo-connection/`;
    this.supervisorApi = `${this.baseUrl}/myaccount/app/api_fw/public/api/`;
    this.documentApi = `${this.baseUrl}/viewer/php/exportTable.php`;
    this.mainSite = this.baseUrl;
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
}